import React from 'react';
import PropTypes from 'react-proptypes';
import ShareLinkItem from './share-link-item';
import Alert from './alert';

export default class ShareLink extends React.Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
    names: PropTypes.arrayOf(PropTypes.string),
    format: PropTypes.string,
  };

  render() {
    // TODO: REMOVE FEATURE FLAG
    const repeatsEnabled = localStorage.getItem('repeats-enabled');
    // @ts-ignore
    const { url, names, format } = this.props;

    const repeatablesMessage = 'Use the following links to access the nested data items for each repeatable section:';
    const jsonMessage = 'This format includes all the repeatable data in the above file';

    return (
      <div style={{ marginTop: 6 }}>
        <ShareLinkItem url={url} />
        {(repeatsEnabled && (names && !!names.length)) && (
          <>
            <div>
              <Alert info>
                <strong>Note: </strong>
                {format === 'json' ? jsonMessage : repeatablesMessage}
              </Alert>
            </div>
            {format !== 'json' && names.map((name, i) => (
              <ShareLinkItem key={i} url={`${url}?repeatable=${name}`} />
            ))}
          </>
        )}
      </div>
    );
  }
}
